import { getFunifierAPIClient } from "./http";

export const funifierApi = getFunifierAPIClient();

// export const api = getAPIClient();
